<template>
  <div class="deskblock">
    <h3>费用占比</h3>
    <div id="pie2"></div>
  </div>
</template>
<script>
import echarts from "echarts";
import axios from "axios";
export default {
  data() {
    return {
      myData: [
       /*  { value: 12, name: "过路费" },
        { value: 6, name: "苦力费" },
        { value: 8, name: "包车费" },
        { value: 8, name: "拼车费" }, */
      ],
      searchItem: {
        startTime: 0,
        endTime: 0,
      },
    };
  },
  methods: {
    getData() {
      ///cloud-tms-server-omc/orders/indexPendingCount
      this.axios({
        method: "post",
        url:
          this.axios.ipPort +
         // "/cloud-tms-server-omc/orders/indexChargesMoneyReport",
          "/cloud-tmsx-server-web/orders/indexChargesMoneyReport",
        data: this.searchItem,
      }).then((res) => {
        var data = res.data.data;
        console.log(data);
        var length = 10;
        if (data.length < 10) {
          length = data.length;
        }
        this.myData.length=0;
        for (let i = 0; i < length; i++) {
          var obj={ value: data[i].totalMoney, name: data[i].name };
          this.myData.push(obj)
        }
        this.drawBar();
      });
    },
    drawBar(id) {
      var that = this;
      this.chart = echarts.init(document.getElementById("pie2"));
      this.option = {
        backgroundColor: "",
        tooltip: {
          trigger: "item",
          // formatter: "{a} <br/>{b}: {c} ({d}%)"
          formatter: "{b}: {c} ({d}%)",
        },
        legend: {
          // orient: "vertical",
          //图例组件
          left: 0, //图例组件离右边的距离
          top: 20,
          orient: "vertical", //布局  纵向布局
          width: 40, //图行例组件的宽度,默认自适应
          x: "right", //图例显示在右边
          itemWidth: 10, //图例标记的图形宽度
          itemHeight: 10, //图例标记的图形高度
          textStyle: {
            //图例文字的样式
            //color: "#fff",
            fontSize: 12,
          },
          //data: ["日常费用", "保养费", "维修费", "加油费"]
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["15%", "50%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            labelLine: {
              show: false,
            },
            data: this.myData,
          },
        ],
        color: [
          "#5e7aff",
          "#1cc3e7",
          "#ef3cf6",
          "#1bc85e",
          "#e8d611",
          "#ed982a",
          "#32e347",
          "#f25454",
          "#f63",
          "#666",
        ],
      };

      this.chart.setOption(this.option);

      this.chart.resize();
    },
    defaultTime() {
      var date = new Date();
      this.yy = date.getFullYear();
      this.mm = date.getMonth();
      this.dd = date.getDate();

      this.searchItem.startTime = new Date(this.yy, 0, 1).getTime();
      this.searchItem.endTime = new Date(this.yy + 1, 0, 1).getTime() - 1000;
      this.getData();
    },
  },
  //调用
  mounted() {
    this.defaultTime();
  },
};
</script>
<style lang="">
#pie2 {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/kanban/block6.vue